import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ExtraProvider } from '../../providers/extra/extra';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {

  notifications:any[];
  showData = false;
  selRegistrationLogin  : any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private extra: ExtraProvider,
    private translate: TranslateService,
    private toast: ToastProvider) {
      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.notifications = [ { 'created_at' : '2020-12-11 16:15:25', 'message' : "New Survey will be Launched 'How many family members' submit date 27-12-2020 ",'demo' : "This is for Demo Purpose Only"},]
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");

      }
else{
    extra.getNotifications().then(val => {
      if(val.status == "success"){
        this.notifications = val.data;
      }else{
        this.toast.presentToast("Unable to fetch notifications");
      }
      this.showData = true;
    })
  }

}
  ionViewDidLoad() {
    console.log('ionViewDidLoad NotificationsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts